import type { TrendItem } from '@/types/home';

export const mockTrends: TrendItem[] = [
  {
    id: 'mock-trend-1',
    title: '요즘 20·30대 다시 꽂힌 필름카메라, 감성 넘어 취미로 자리 잡아',
    summary: '디지털에 지친 젊은 세대가 필름카메라를 다시 찾고 있어요. 현상 기다리는 설렘과 따뜻한 색감이 매력 포인트로 꼽혀요.',
    url: 'https://www.example.com/trend/film-camera',
    source: '트렌드데스크',
    publishedAt: '2026-09-14T01:00:00.000Z',
    category: 'hobby',
  },
  {
    id: 'mock-trend-2',
    title: '주말마다 성수·연남 대신 찾는 근교 핫플, 조용한 소도시 원정 인기',
    summary: '붐비는 도심 대신 한적한 근교 소도시로 떠나는 짧은 여행이 뜨고 있어요. 기차로 한두 시간 거리가 특히 인기예요.',
    url: 'https://www.example.com/trend/weekend-city',
    source: '트렌드데스크',
    publishedAt: '2026-09-13T22:00:00.000Z',
    category: 'hotplace',
  },
  {
    id: 'mock-trend-3',
    title: '일하며 휴가 즐기는 워케이션 유행, 카페 대신 소도시 한 달 살기로',
    summary: '노트북 하나로 다른 도시에서 한 달을 지내는 워케이션이 확산 중이에요. 숙소·카페 업계도 전용 상품을 늘리고 있어요.',
    url: 'https://www.example.com/trend/workation',
    source: '트렌드데스크',
    publishedAt: '2026-09-13T09:00:00.000Z',
    category: 'trend',
  },
  {
    id: 'mock-trend-4',
    title: '퇴근 후 30분 러닝크루, 요즘 직장인들의 새로운 취미 모임',
    summary: '혼자 뛰기 부담스러운 초보들 사이에서 러닝크루가 인기예요. 함께 달리고 기록을 나누는 재미에 빠졌어요.',
    url: 'https://www.example.com/trend/running-crew',
    source: '트렌드데스크',
    publishedAt: '2026-09-12T12:00:00.000Z',
    category: 'hobby',
  },
  {
    id: 'mock-trend-5',
    title: '가을 맞이 캠핑 대신 차박, 20대 사이 간편 캠핑 뜬다',
    summary: '장비 부담을 줄인 차박이 젊은 층에서 인기예요. 짧게 떠나고 가볍게 즐기는 방향으로 취향이 옮겨가고 있어요.',
    url: 'https://www.example.com/trend/car-camping',
    source: '트렌드데스크',
    publishedAt: '2026-09-12T03:00:00.000Z',
    category: 'hobby',
  },
  {
    id: 'mock-trend-6',
    title: '도심 속 팝업스토어 성지로 떠오른 골목, 주말마다 대기 행렬',
    summary: '짧게 열리는 팝업을 따라 도시 구석구석을 탐험하는 재미가 유행이에요. 이번 주말에도 여러 팝업이 예정돼 있어요.',
    url: 'https://www.example.com/trend/popup',
    source: '트렌드데스크',
    publishedAt: '2026-09-11T15:00:00.000Z',
    category: 'hotplace',
  },
  {
    id: 'mock-trend-7',
    title: '소확행 넘어 리추얼로, 요즘 2030이 아침을 사는 법',
    summary: '거창한 계획보다 매일 반복하는 작은 루틴이 화두예요. 기상 후 10분 스트레칭과 기록하는 습관이 인기예요.',
    url: 'https://www.example.com/trend/ritual',
    source: '트렌드데스크',
    publishedAt: '2026-09-11T02:00:00.000Z',
    category: 'trend',
  },
  {
    id: 'mock-trend-8',
    title: '취미로 시작한 베이킹 클래스, 원데이 인기 강좌 순위 공개',
    summary: '주말 반나절을 투자해 디저트 하나를 완성하는 원데이 클래스가 인기예요. 만들고 나눠 먹는 재미가 있어요.',
    url: 'https://www.example.com/trend/baking-class',
    source: '트렌드데스크',
    publishedAt: '2026-09-10T07:00:00.000Z',
    category: 'hobby',
  },
];